/*
 * @Author: Hyman Choi
 * @Date: 2021-01-26 13:57:09
 * @LastEditTime: 2021-12-27 16:45:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\userManagement.js
 */
import request from '@/utils/request'
import config from '@/utils/config'
import {handleUrlEncode} from "@/utils/urlutil";

/**
 * 获取所有用户列表
 *
 * @param {*} params
 */
export function getAllUserList(params) {
	let url = config.API_ADMIN + '/Api/V1/AdminUsers/AllUserList?'
	url = handleUrlEncode(url,params)
	return request({
		url: url,
		method: 'get',
	})
}

/**
 * 删除单个用户
 *
 * @param {*} params
 */
export function deleteUser(params) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminUsers/Delete',
		method: 'delete',
		params
	})
}

/**
 * 修改单个用户状态(停用/正常)
 *
 * @param {*} data
 */
export function forbiddenUser(data) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminUsers/ForbiddenOrCancel',
		method: 'patch',
		data
	})
}

/**
 * 修改单个用户状态(推荐用户)
 *
 * @param {*} data
 */
export function recommendUser(data) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminUsers/RecommendOrNot',
		method: 'patch',
		data
	})
}

/**
 * 获取所有待认证用户列表
 *
 * @param {*} params
 */
export function getUserCertificationList(params) {
	let url = config.API_ADMIN + '/Api/V1/AdminUsers/UserCertificationList?'
	url = handleUrlEncode(url,params)
	return request({
		url: url,
		method: 'get',
	})
}

/**
 * 设置待认证用户状态
 *
 * @param {*} data
 */
export function setUserCertificate(data) {
	return request({
		url: config.API_ADMIN + '/Api/V1/AdminUsers/UserCertificate/Status',
		method: 'patch',
		data
	})
}

/**
 * @description: 后台通过手机号/用户id/登录名/邮箱查询用户信息
 * @param {*} params
 * @return {*}
 */
export function searchUserInfo(params) {
	return request({
		url: config.API_MEDICAL + '/Api/V1/AdminUsers/UserInfo',
		method: 'get',
		params
	})
}

/**
 * 用户注册
 * @param {Object} params
 */
export function registerUser(params) {
	return request({
		url: config.API_ADMIN + "/Api/V1/AdminUsers/Fast/Register",
		method: "post",
		data: params
	})
}
